// /src/pages/admin/clientes/CreateCustomer.jsx
import React, { useState } from "react";
import axios from "../../../api/axios"; // Ajusta si usas alias "api/*" -> import axios from "api/axios";
import { useNavigate } from "react-router-dom";

export default function CreateCustomer() {
  const navigate = useNavigate();

  // Estado del formulario
  const [form, setForm] = useState({
    identification: "",
    name: "",
    address: "",
    phone_home: "",
    phone_mobile: "",
    email: "",
    install_date: "",
    technician: "",
    observations: "",
    latitude: "",
    longitude: "",
  });

  // Manejo de cambios en inputs
  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  // Enviar formulario
  const handleSubmit = async () => {
    try {
      await axios.post("/customers/", form);
      alert("Cliente registrado correctamente");
      // Navegar a la lista de instalaciones o clientes
      navigate("/clientes/instalaciones");
    } catch (err) {
      console.error(err);
      alert("Error al registrar cliente");
    }
  };

  return (
    <div className="container mx-auto p-4">
      <h1 className="text-xl font-bold mb-4">Nuevo Registro de Cliente</h1>

      <div className="grid grid-cols-2 gap-4">
        <input
          placeholder="Nº Identificación"
          name="identification"
          value={form.identification}
          onChange={handleChange}
        />
        <input
          placeholder="Nombres y Apellidos"
          name="name"
          value={form.name}
          onChange={handleChange}
        />
        <input
          placeholder="Dirección"
          name="address"
          value={form.address}
          onChange={handleChange}
        />
        <input
          placeholder="Teléfono Casa"
          name="phone_home"
          value={form.phone_home}
          onChange={handleChange}
        />
        <input
          placeholder="Teléfono Móvil"
          name="phone_mobile"
          value={form.phone_mobile}
          onChange={handleChange}
        />
        <input
          placeholder="Correo"
          name="email"
          value={form.email}
          onChange={handleChange}
        />
        <input
          type="datetime-local"
          placeholder="Fecha y Hora de instalación"
          name="install_date"
          value={form.install_date}
          onChange={handleChange}
        />
        <input
          placeholder="Asignar Técnico"
          name="technician"
          value={form.technician}
          onChange={handleChange}
        />
        <input
          placeholder="Observaciones"
          name="observations"
          value={form.observations}
          onChange={handleChange}
        />
        <input
          placeholder="Latitud"
          name="latitude"
          value={form.latitude}
          onChange={handleChange}
        />
        <input
          placeholder="Longitud"
          name="longitude"
          value={form.longitude}
          onChange={handleChange}
        />
      </div>

      <div className="mt-4 flex gap-2">
        {/* Cerrar vuelve a la lista de clientes */}
        <button
          className="bg-gray-500 px-4 py-2 rounded"
          onClick={() => navigate("/clientes")}
        >
          Cerrar
        </button>

        {/* Registrar cliente */}
        <button
          className="bg-blue-600 text-white px-4 py-2 rounded"
          onClick={handleSubmit}
        >
          Registrar
        </button>
      </div>
    </div>
  );
}
